/* Tooltip */
var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});
/* / Tooltip */

/* Alerts */
var alertList = document.querySelectorAll(".alert");
var alerts = [].slice.call(alertList).map(function (element) {
  return new bootstrap.Alert(element);
});
/* / Alerts */

/* Popovers */
var popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl);
});
/* / Popovers */
